import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Gift, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const GIFT_TSHIRT = 5000;
const GIFT_CAP = 6000;

export const GiftAlert = () => {
  const { subtotal } = useCart();
  const prev = useRef(subtotal);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    const crossed = (t) => prev.current < t && subtotal >= t;
    if (crossed(GIFT_CAP)) setAlert("cap");
    else if (crossed(GIFT_TSHIRT)) setAlert("tee");
    prev.current = subtotal;
  }, [subtotal]);

  useEffect(() => {
    if (!alert) return;
    const t = setTimeout(() => setAlert(null), 5000);
    return () => clearTimeout(t);
  }, [alert]);

  return (
    <AnimatePresence>
      {alert && (
        <div
          className="fixed bottom-24 sm:bottom-6 inset-x-0 z-[150] flex justify-center px-4 pointer-events-none"
          data-testid="gift-alert"
        >
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.95 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="bg-[#4A148C] text-white rounded-2xl shadow-2xl p-4 flex items-center gap-4 w-full max-w-sm pointer-events-auto"
          >
            <div className="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
              <Gift size={22} className="text-[#FFD600]" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-display font-bold text-base leading-tight" data-testid="gift-alert-title">
                {alert === "cap" ? "That's proppa — T-shirt AND Cap!" : "That's proppa — free T-shirt!"}
              </p>
              <p className="text-xs font-medium text-white/75 mt-1">
                {alert === "cap"
                  ? "Both are going in your parcel, on us."
                  : "It's going in your parcel, on us. Pick your design in the basket."}
              </p>
            </div>
            <button
              onClick={() => setAlert(null)}
              aria-label="Dismiss"
              data-testid="gift-alert-dismiss"
              className="text-white/60 hover:text-white transition-colors shrink-0"
            >
              <X size={16} />
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
